import React, { useEffect, useState } from 'react';
import Header from '../../../components/Header/Header';
import Footer from '../../../components/Footer/Footer';
import ComponentPageTitle from '../../../components/PageTitle';
import CenteredContainer from '../../../components/CenteredContainer';
import PageName from '../../../components/PageName';
import Spacer from '../../../components/Spacer';
import { Sushiwari } from '../thumbnail_images';

import { workData } from '../WorkData';
import ProductPageH2 from '../mini_components/ComponentProductPageH2';
import SushiwariImage1 from '../../../assets/images/product_pages/sushiwari/sushiwari_1.png';
import SushiwariImage2 from '../../../assets/images/product_pages/sushiwari/sushiwari_2.png';
import SushiwariImage3 from '../../../assets/images/product_pages/sushiwari/sushiwari_3.png';
import SushiwariImage4 from '../../../assets/images/product_pages/sushiwari/sushiwari_4.png';
import SushiwariImage5 from '../../../assets/images/product_pages/sushiwari/sushiwari_5.png';
import SushiwariImage6 from '../../../assets/images/product_pages/sushiwari/sushiwari_6.png';
import SushiwariImage7 from '../../../assets/images/product_pages/sushiwari/sushiwari_7.png';
import SushiwariImage8 from '../../../assets/images/product_pages/sushiwari/sushiwari_8.png';
import SushiwariImage10 from '../../../assets/images/product_pages/sushiwari/sushiwari_10.png';
import SushiwariImage11 from '../../../assets/images/product_pages/sushiwari/sushiwari_11.png';
import PreviewGoogleDrivePdf from '../../../components/PreviewGoogleDrivePdf';
import CircleNum from '../mini_components/CircleNum';

import { ArrowDownwardOutlined } from '@mui/icons-material';
import CircleNumP from '../mini_components/CircleNumP';
import ComponentProductHeader from '../mini_components/ComponentProductHeader';
import SpanBold from '../../../components/SpanBold';



const ProductSushiwari = () => {
    const sushiwariData = workData.find(item => item.title === "スシワリ");
    const [isDesktop, setIsMobile] = useState(window.innerWidth > 767);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth > 767);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    PageName("スシワリ - 制作物");

    return (<>
        <Header />
        <CenteredContainer>
        <ComponentPageTitle title="スシワリ - 制作物" />

        {/* ================================================= 冒頭部分 ================================================= */}
        <ComponentProductHeader isDesktop={isDesktop} data={sushiwariData} />
        {/* ========================================================================================================== */}


        {/* ============================================== 解決したい課題 =============================================== */}
        <ProductPageH2>解決したい課題</ProductPageH2>
        <ul style={{ color: 'var(--common-main-color)', fontSize: '110%' }}>
            <p>複数人の回転寿司店での食事に存在する、次の2つの課題を解決するために開発しました：</p>
            <Spacer height={20} />
            <ol style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                padding: 0,
                margin: 0
            }}>
                {/* 1つ目の項目 */}
                <li style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginRight: '50px',
                    textAlign: 'center'
                }}>
                    <p><CircleNum>1</CircleNum>金額や枚数が様々だから計算しづらい</p>
                    <img src={SushiwariImage1} alt="スシワリ課題1" style={{ width: '100%', maxWidth: '380px', margin: '10px 0' }} />
                </li>

                {/* 2つ目の項目 */}
                <li style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                }}>
                    <p><CircleNum>2</CircleNum>いたずらで誰かが他人のお皿の山にお皿を乗せてしまう</p>
                    <img src={SushiwariImage2} alt="スシワリ課題2" style={{ width: '100%', maxWidth: '380px', margin: '10px 0' }} />
                </li>
            </ol>
        </ul>
        {/* ========================================================================================================== */}


        {/* ================================================== 機能 =================================================== */}
        <ProductPageH2>機能</ProductPageH2>
        <ul style={{ color: 'var(--common-main-color)', fontSize: '110%' }}>
            <p>人・種類ごとの皿のカウント機能によって、<SpanBold></SpanBold> 不公平感が低くなるような 各メンバーごとの割り勘額 を提示します。</p>
        </ul>
        {/* ========================================================================================================== */}


        {/* ================================================== 使い方 ================================================== */}
        <ProductPageH2>使い方</ProductPageH2>
        <ul style={{ display: 'flex', flexWrap: 'wrap', gap: '40px 15px', fontSize: '110%' }}>
            <div style={{width: '450px'}}>
                <p><CircleNum>1</CircleNum>グループを意味する「つどい」を作成する</p>
                <img src={SushiwariImage3} alt="スシワリ使い方1" style={{ width: '100%', maxWidth: '340px', margin: '10px 0' }} />
            </div>
            <div style={{width: '450px'}}>
                <p><CircleNum>2</CircleNum>メンバーを意味する「なかま」を作成する</p>
                <img src={SushiwariImage4} alt="スシワリ使い方2" style={{ width: '100%', maxWidth: '340px', margin: '10px 0' }} />
            </div>
            <div style={{width: '900px'}}>
                <p><CircleNum>3</CircleNum>食事中に枚数を加算していく</p>
                <div style={{ display: 'flex' }}>
                    <img src={SushiwariImage5} alt="スシワリ使い方3-1" style={{ width: '100%', maxWidth: '450px', margin: '10px 0' }} />
                    <img src={SushiwariImage6} alt="スシワリ使い方3-2" style={{ width: '100%', maxWidth: '450px', margin: '10px 0' }} />
                </div>
            </div>
            <div style={{width: '450px'}}>
                <p><CircleNum>4</CircleNum>食事後の合計金額を入力する</p>
                <img src={SushiwariImage7} alt="スシワリ使い方4" style={{ width: '100%', maxWidth: (isDesktop) ? '320px' : '100%', margin: '10px 0' }} />
            </div>
            <div style={{width: '450px'}}>
                <p><CircleNum>5</CircleNum>割り勘金額が表示される</p>
                <img src={SushiwariImage8} alt="スシワリ使い方5" style={{ width: '100%', maxWidth: '320px', margin: '10px 0' }} />
            </div>
        </ul>
        {/* ========================================================================================================== */}



        {/* ============================================= 既存サービスとの比較 =========================================== */}
        <ProductPageH2>既存サービスとの比較</ProductPageH2>
        <ul>
            <p>
                <CircleNum>1</CircleNum>アプリケーションストア（AppStore, Google Playストア）を検索したところ、回転寿司に特化した割り勘アプリは見当たらない
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', color: 'var(--common-main-color)', margin: '18px 0' }}><ArrowDownwardOutlined /></div>
                <p style={{ textAlign: 'center' }}>新たな価値を生み出す</p>
            </p>
            <Spacer height={50} />
            <p>
                <CircleNumP num={2}>既存の割り勘アプリは「メニュー」と「金額」を入力する仕組みになっており、回転寿司のような決まった金額の繰り返しの入力は手間がかかったり、入力ミスをする可能性がある</CircleNumP>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', color: 'var(--common-main-color)', margin: '18px 0' }}><ArrowDownwardOutlined /></div>
                <p style={{ textAlign: 'center' }}>お皿の種類ごとの「枚数」を管理するだけでよい</p>
            </p>
        </ul>
        {/* ========================================================================================================== */}



        {/* ==================================== ユーザーの使いやすさのために工夫した点 ===================================== */}
        <ProductPageH2>ユーザーの使いやすさのために工夫した点</ProductPageH2>
        <ul>
            <p>
                <CircleNum>1</CircleNum>寿司屋や回転寿司の世界観を表現するために、各部分の名称やデザインを寿司屋の雰囲気に合わせた
                <div style={{ margin: '10px 45px' }}>
                    <p>例：</p>
                </div>
                <ul style={{ margin: '0 50px' }}>
                    <li>「グループ」を「つどい」、「メンバー」を「なかま」、「会計」を「おあいそ」という名称に変更</li>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <img src={SushiwariImage10} alt="スシワリ ユーザー視点1" style={{ width: '100%', maxWidth: '320px', marginTop: '10px', marginBottom: '20px' }} />
                    </div>
                    <li>アプリアイコンに親しみやすいデザインを採用</li>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <img src={Sushiwari} alt="スシワリ ユーザー視点2" style={{ width: '100%', maxWidth: '170px', marginTop: '10px', marginBottom: '20px' }} />
                    </div>
                </ul>
            </p>
            <Spacer height={50} />
            <p>
                <CircleNumP num={2}>直感的に使用できるよう、できるだけシンプルなUIを採用した</CircleNumP>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <img src={SushiwariImage11} alt="スシワリ ユーザー視点2" style={{ width: '100%', maxWidth: '270px', marginTop: '10px', marginBottom: '20px' }} />
                </div>
            </p>
        </ul>
        {/* ========================================================================================================== */}



        {/* ================================================= デモ動画 ================================================= */}
        <ProductPageH2>デモ動画</ProductPageH2>
        <ul>
            <PreviewGoogleDrivePdf fileId="1Z1M7Q7QKbvPMspvZEwnIix54uxIOKtUG" />
        </ul>
        {/* ========================================================================================================== */}


        </CenteredContainer>
        <Footer />
    </>);
};



export default ProductSushiwari;